import {TableSortLabel} from '@mui/material'
import useTableSort from 'logic/useTableSort'
import React from 'react'

const TableSort = ({itemName, itemKey, children}) => {
    const {showSort, onClickDirection, direction} = useTableSort(itemName, itemKey?.key ?? itemKey)
    return (
        <>
            {showSort ? (
                <TableSortLabel
                    active={!!direction}
                    direction={direction}
                    onClick={onClickDirection}>
                    {children}
                </TableSortLabel>
            ) : (
                children
            )}
        </>
    )
}

export default TableSort
